export default interface IDrugAssessment {
    HasUsageInPastYear?: boolean;
    HasUsedOtherThanMedicalReason?: boolean;
    HasAbusedMoreThanOne?: boolean;
    UnableToStop?: boolean;
    HasBlackoutsOrFlashback?: boolean;
    FeltGuiltyAbout?: boolean;
    FamilyComplained?: boolean;
    NeglectedFamily?: boolean;
    EngagedInIllegalActivityToObtainDrug?: boolean;
    IsExperiencedWithdrawalSymptoms?: boolean;
    HasMedicalProblemsDueToDrugUsage?: boolean;
    Score?: number;
    IsAIHasUsageInPastYear?: boolean;
    IsAIHasUsedOtherThanMedicalReason?: boolean;
    IsAIHasAbusedMoreThanOne?: boolean;
    IsAIUnableToStop?: boolean;
    IsAIHasBlackoutsOrFlashback?: boolean;
    IsAIFeltGuiltyAbout?: boolean;
    IsAIFamilyComplained?: boolean;
    IsAINeglectedFamily?: boolean;
    IsAIEngagedInIllegalActivityToObtainDrug?: boolean;
    IsAIIsExperiencedWithdrawalSymptoms?: boolean;
    IsAIMedicalProblemsDueToDrugUsage?: boolean;
}

export class DrugAssessment implements IDrugAssessment {
    HasUsageInPastYear?: boolean;
    HasUsedOtherThanMedicalReason?: boolean;
    HasAbusedMoreThanOne?: boolean;
    UnableToStop?: boolean;
    HasBlackoutsOrFlashback?: boolean;
    FeltGuiltyAbout?: boolean;
    FamilyComplained?: boolean;
    NeglectedFamily?: boolean;
    EngagedInIllegalActivityToObtainDrug?: boolean;
    IsExperiencedWithdrawalSymptoms?: boolean;
    HasMedicalProblemsDueToDrugUsage?: boolean;
    Score?: number;
    IsAIHasUsageInPastYear?: boolean;
    IsAIHasUsedOtherThanMedicalReason?: boolean;
    IsAIHasAbusedMoreThanOne?: boolean;
    IsAIUnableToStop?: boolean;
    IsAIHasBlackoutsOrFlashback?: boolean;
    IsAIFeltGuiltyAbout?: boolean;
    IsAIFamilyComplained?: boolean;
    IsAINeglectedFamily?: boolean;
    IsAIEngagedInIllegalActivityToObtainDrug?: boolean;
    IsAIIsExperiencedWithdrawalSymptoms?: boolean;
    IsAIHasMedicalProblemsDueToDrugUsage?: boolean;

    constructor() {
        this.HasUsageInPastYear = null;
    }
}
